import(/* webpackMode: "eager" */ "/app/src/app/[locale]/product/[slug]/error.tsx");
